package com.schoolconnect.app.feature.auth

import com.schoolconnect.app.feature.rolepicker.RolePickerUiState

data class AuthUiState(
    val loginId: String = "",
    val otp: String = "",
    val isOtpSent: Boolean = false,
    val isOtpVerified: Boolean = false,
    val isLoading: Boolean = false,
    val errorMessage: String = "",
    val infoMessage: String = "",
    val errorNonce: Int = 0,
    val otpCountdownSeconds: Int = 0,
    val rolePicker: RolePickerUiState = RolePickerUiState()
)

sealed interface AuthUiEvent {
    data object BackClicked : AuthUiEvent
    data object SendOtpClicked : AuthUiEvent
    data object ResendOtpClicked : AuthUiEvent
    data object VerifyOtpClicked : AuthUiEvent
    data object RolePickerClosed : AuthUiEvent
    data object RolePickerRequested : AuthUiEvent
    data object RolePickerContinueClicked : AuthUiEvent
    data class RolePickerSelectionChanged(val optionId: String) : AuthUiEvent
    data class RolePickerRememberChanged(val value: Boolean) : AuthUiEvent
    data class LoginIdChanged(val value: String) : AuthUiEvent
    data class OtpChanged(val value: String) : AuthUiEvent
}
